<template>
    <div
        v-if="filteredAlerts.length"
        class="alerts-carousel"
        :class="{ 'property-alerts': view === 'property' }"
    >
        <CardCarousel
            :seeAllUrl="seeAllUrl"
            :numCards="filteredAlerts.length"
            :title="title"
            :description="description"
        >
            <template #carouselCard>
                <Slide
                    v-for="(alert, i) in filteredAlerts"
                    :key="i"
                    :class="{ 'h-44': view === 'property' }"
                >
                    <AlertItem
                        :alert="alert"
                        :widgetView="true"
                        :includeImage="view !== 'property'"
                    />
                </Slide>
            </template>
        </CardCarousel>
    </div>
    <!-- START EMPTY STATE - NO ALERTS FOUND -->
    <div v-else-if="view !== 'property'">
        <div class="flex justify-between pb-2">
            <div
                class="grow shrink basis-0 flex-col justify-end items-start gap-1 flex"
            >
                <h2
                    class="text-slate-800/95 dark:text-slate-100 text-lg font-medium leading-7"
                >
                    {{ title }}
                </h2>
            </div>
            <router-link
                class="flex items-end text-slate-800 dark:text-slate-100 text-sm font-medium hover:text-slate-500 active:text-slate-500 dark:hover:text-slate-400 dark:active:text-slate-400 focus:outline-none"
                :to="seeAllUrl"
                role="button"
            >
                See all
            </router-link>
        </div>
        <div class="rounded-lg border border-slate-200 dark:border-slate-700 py-16">
            <EmptyState
                title="No active alerts"
                description="Create your first alert to track and be notified of award availability for your favorite hotels."
                action-label="Create Alert"
                @action="createAlert"
            >
                <template #image>
                    <div
                        class="w-16 h-16 bg-slate-200 dark:bg-slate-700 rounded-full justify-center items-center flex text-slate-600 dark:text-slate-300"
                    >
                        <Icon icon="alert" />
                    </div>
                </template>
            </EmptyState>
        </div>
    </div>
    <ManageAlertModal
        :show="showAlertModal"
        @close="setShowAlertModal(false)"
    />
</template>
<script>
import 'vue3-carousel/dist/carousel.css';
import { storeToRefs } from 'pinia';
import { useAlertsStore } from '@/store/alerts';
import { useHotelsStore } from '@/store/hotels';
import { Slide } from 'vue3-carousel';
import AlertItem from '@/components/alerts/alert-item.vue';
import ManageAlertModal from '@/components/alerts/modals/manage-alert-modal/manage-alert-modal.vue';
import CardCarousel from '@/components/ui/card-carousel/card-carousel.vue';
import EmptyState from '@/components/ui/empty-state/empty-state.vue';
import Icon from '@/components/ui/icon/icon.vue';

export default {
    props: {
        view: { type: String, default: 'alertsArchive' },
        title: { type: String, required: false },
        description: { type: String, required: false },
    },
    components: {
        AlertItem,
        CardCarousel,
        EmptyState,
        Icon,
        ManageAlertModal,
        Slide,
    },
    setup(props) {
        const alertsStore = useAlertsStore();
        const hotelsStore = useHotelsStore();
        const seeAllUrl = '/alerts';
        const { setShowAlertModal, getAlerts, replaceSelectedProperties } =
            alertsStore;
        const { filteredAlerts, selectedAlert, showAlertModal } =
            storeToRefs(alertsStore);

        if (props.view === 'property' && hotelsStore.property?.id) {
            replaceSelectedProperties([hotelsStore.property.id]);
        }

        const createAlert = () => {
            setShowAlertModal(true);
        };

        getAlerts();

        return {
            filteredAlerts,
            alertsStore,
            createAlert,
            seeAllUrl,
            selectedAlert,
            setShowAlertModal,
            showAlertModal,
        };
    },
};
</script>

<style lang="scss"></style>
